const TC_CLAUSES = [
  {
    id: "1",
    text: "1. OWNERSHIP: Notwithstanding anything else provided, express or implied, ownership of goods sold before and after delivery shall remain vested in Argus Motor Co. ('company') and shall not pass to the purchaser until all amounts due have been paid in full.",
  },
  {
    id: "2",
    text: "2. PAYMENT:",
  },
  {
    id: "2a",
    text: "a. In the event of payment not being made timeously, we shall be entitled at our sole option, to cancel this sale and repossess the goods from you and claim all damages suffered by us. Alternatively, we shall be entitled to recover any balance due to us.",
    indent: true,
  },
  {
    id: "2b",
    text: "b. In the event of us deciding to repossess the goods, you irrevocably appoint us as your agent to retake possession of the goods wherever the same might be. In the event of any legal action by us, you agree to the local Magistrate's Court of your area having jurisdiction and furthermore, you will be responsible for costs of the attorney on own client scale.",
    indent: true,
  },
  {
    id: "2c",
    text: "c. The company reserves the right to charge interest on a monthly basis on overdue accounts at a rate of 15.5% p.a.",
    indent: true,
  },
  {
    id: "3",
    text: "3. CLAIMS:",
  },
  {
    id: "3a",
    text: "a. All goods are checked under CCTV surveillance, any claims for short deliveries will not be considered unless made in writing to us for our consideration within a 48 hour period from delivery.",
    indent: true,
  },
  {
    id: "3b",
    text: "b. All goods to be delivered are under CCTV surveillance. Short delivery claims must be made in writing and forwarded to the company for consideration within 48 hours from date of delivery.",
    indent: true,
  },
  {
    id: "3c",
    text: "c. Goods returned without Seller's prior written consent shall not be accepted for credit.",
    indent: true,
  },
  {
    id: "3d",
    text: "d. All returned goods that Seller has agreed to accept must be in original packaging and in a saleable condition acceptable to the company, with a handling fee of 15% of the value of goods prepaid.",
    indent: true,
  },
  {
    id: "3e",
    text: "e. No credit will be allowed for any goods returned more than Ten (10) days after delivery date.",
    indent: true,
  },
  {
    id: "4",
    text: "4. DELIVERY AGENTS: Any carrier other than ourselves is deemed to be acting as agent for the purchaser.",
  },
  {
    id: "5",
    text: "5. LIABILITY: Apart from the terms of any written guarantee on specific goods, the company will at its discretion consider replacement or reimbursement in respect of any goods supplied which are proved defective either in materials or workmanship, having regard to the use already or previously obtained from them. Safety critical components must be fitted by suitably qualified Automotive Technicians in an accredited workshop. The company shall not be liable for any defects in goods delivered or for any injury, damage or loss, consequential or otherwise resulting from such defect or delivery or use of the goods.",
  },
];

export default TC_CLAUSES;
